import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';
import { Container } from '@/components/ui/Page';
import { EmptyState } from '@/components/ui/States';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Container narrow>
      <EmptyState
        icon={<Compass />}
        title={t('errors.pageNotFound')}
        action={
          <Button asChild variant="primary">
            <Link to="/">{t('common.goHome')}</Link>
          </Button>
        }
      >
        {t('errors.pageNotFoundBody')}
      </EmptyState>
    </Container>
  );
}
